import { Text } from 'govwell-ui'

type AskedCountCellProps = {
  count: number
}

const AskedCountCell = ({ count }: AskedCountCellProps) => {
  return <Text.Body>{count}</Text.Body>
}

export default React.memo(AskedCountCell)
